import {useTranslation} from 'react-i18next'
import {TSupportLinkProps} from './utils'
import {getLocalizedSupportUrl} from '~/utils/routes.support'

export const TSupportLink = ({to, ...props}: TSupportLinkProps) => {
  const {i18n} = useTranslation()

  const localizedTo = getLocalizedSupportUrl(i18n.language, to)

  return <a {...props} href={localizedTo.url} />
}
